// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal--editproductmodal{overflow:auto;width:100%;max-width:600px !important;max-height:95vh;overflow:auto}.modal--editproductmodal::-webkit-scrollbar{width:16px;outline:none;padding:0 4px}.modal--editproductmodal::-webkit-scrollbar-track{width:8px;background:#232f3f;padding:0 4px}.modal--editproductmodal::-webkit-scrollbar-thumb{background:#455566;border-radius:2px;border-left:4px solid #232f3f;border-right:4px solid #232f3f}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
